import { Controller } from '@hotwired/stimulus'
import { put } from '@rails/request.js'

const lifetime = 3000
const hiddenClass = 'hidden'

export default class extends Controller {
  static targets = ['copyLinkBtn', 'form', 'copyConfirmation']

  copyLink() {
    this.copyLinkToClipboard()
    this.showCopyConfirmationMessage()
  }

  // private

  showCopyConfirmationMessage() {
    this.copyConfirmationTarget.classList.remove(hiddenClass)

    setTimeout(() => {
      if (this.hasCopyConfirmationTarget) this.copyConfirmationTarget.classList.add(hiddenClass)
    }, lifetime)
  }

  copyLinkToClipboard() {
    const link = this.copyLinkBtnTarget.dataset.sharedReportUrl
    navigator.clipboard.writeText(link)
  }

  submitForm() {
    const url = this.formTarget.getAttribute('action')
    const formData = new FormData(this.formTarget)

    put(url, { responseKind: 'turbo-stream', body: formData })
  }
}
